import { useState } from 'react';
// @mui
import {
  TableContainer,
  Table,
  TableHead,
  TableCell,
  TableBody,
  TableRow,
} from '@mui/material';
// hooks
import useCompany from '../../hooks/useCompany';
// components
import Scrollbar from '../../components/Scrollbar';
import {
  CrewsTableRow,
  CrewProfileDialog,
} from './';


const TABLE_HEAD = [
  { id: 'nickname', label: '크루 닉네임', align: 'center' },  // id, 상세 포지션 or 자동매칭 포지션
  { id: 'position', label: '포지션', align: 'center' },
  { id: 'status', label: '계약 상태', align: 'center' },  // 키보드 개발자 이름 닉네임
  { id: 'endDate', label: '계약 종료일', align: 'center' },
  { id: 'link' }, // 매칭 n일째, 회사무응답 n회, 
];

export default function CrewsTable() {
  const { crews } = useCompany();
  const [selectedProfile, setSelectedProfile] = useState(null);

  return (
    <Scrollbar>
      <TableContainer sx={{ py: 2, px: 1 }}>
      <Table size={'medium'}>
        <CrewsTableHead
          headLabel={TABLE_HEAD}
          sx={{ whiteSpace: 'nowrap' }}
        />
        <TableBody>
          {crews && crews.map((row) => (
            <CrewsTableRow
              key={row.id}
              row={row}
              openProfileDialog={() => setSelectedProfile(row)}
            />
          ))}
        </TableBody>
      </Table>
      </TableContainer>
      <CrewProfileDialog
        isOpen={Boolean(selectedProfile)}
        closeDialog={() => setSelectedProfile(null)}
        crew={selectedProfile}
      />
    </Scrollbar>
  )
}

function CrewsTableHead({
  headLabel,
  sx,
}) {
  return (
    <TableHead sx={sx}>
      <TableRow>
        {headLabel.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={headCell.align || 'left'}
            sx={{ width: headCell.width, minWidth: headCell.minWidth }}
          >
            {headCell.label}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}
